import { render } from "./FileColumnMapping.vue?vue&type=template&id=18672461"
import script from "./FileColumnMapping.vue?vue&type=script&lang=js"
export * from "./FileColumnMapping.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/pathways/FileColumnMapping.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18672461"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18672461', __exports__)) {
    api.reload('18672461', __exports__)
  }
  
  module.hot.accept("./FileColumnMapping.vue?vue&type=template&id=18672461", () => {
    api.rerender('18672461', render)
  })

}


export default __exports__